import { render } from "./top-text.vue?vue&type=template&id=204908ee&scoped=true"
import script from "./top-text.vue?vue&type=script&lang=js"
export * from "./top-text.vue?vue&type=script&lang=js"

import "./top-text.vue?vue&type=style&index=0&id=204908ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204908ee"]])

export default __exports__